export enum ControlType {
    Text = 'text',    
    Number = 'number',
    Dropdown = 'dropdown',
    Calendar = 'calendar',
    Checkbox = 'checkbox',
    FileUpload = 'file-upload',
    InputMask = 'input-mask',
    Label = 'label',
    TextArea = 'textarea',
    SubFormulario = 'sub-formulario'
}